import { createAsyncThunk } from '@reduxjs/toolkit';
import i18n from 'i18next';
import { batch } from 'react-redux';
import { queryClient } from '../../api/APIProvider';
import { ILanguage } from '../../config/i18n/common';
import { LoginDTO } from '../../interfaces/auth.interface';
import { loginService, logoutService } from '../../services/auth.service';
import {
  clearStorage,
  getLanguageStorage,
  getUserStorage,
  setLanguageStorage,
  setUserStorage,
} from '../../services/localStorage.service';
import { getCompaniesAsync, resetCompanies } from '../companies/companiesSlice';
import { resetCore, setCoreLoading } from '../core/coreSlice';
import { setCurrentLanguage, setLangLoading, setUser, setUserLoading } from './userSlice';

export const loadAppAsync = createAsyncThunk('user/loadUserAsync', async (_, { dispatch }) => {
  dispatch(setUserLoading({ value: true }));

  await dispatch(loadUserAsync());
  await dispatch(loadLangAsync());
  await dispatch(getCompaniesAsync());

  dispatch(setUserLoading({ value: false }));
});

export const loadUserAsync = createAsyncThunk('user/loadUserAsync', async (_, { dispatch }) => {
  const userData = await getUserStorage();
  dispatch(setUser({ user: userData }));

  return userData;
});

export const loadLangAsync = createAsyncThunk('user/loadLangAsync', async (_, { dispatch }) => {
  const lang = await getLanguageStorage();
  if (lang) {
    dispatch(setLanguageAsync(lang));
  }
});

/**
 * Set current language
 */
export const setLanguageAsync = createAsyncThunk(
  'user/setLanguageAsync',
  async (currentLanguage: ILanguage, { dispatch }) => {
    dispatch(setLangLoading({ value: true }));
    dispatch(setCurrentLanguage({ currentLanguage }));
    await i18n.changeLanguage(currentLanguage.value);
    await setLanguageStorage(currentLanguage);
    // await dispatch(updateUserDataAsync({ lang: currentLanguage.value } as IUpdateUserData, false));
    dispatch(setLangLoading({ value: false }));
  },
);

//////////////////////////////// LOGIN ASYNC ACTIONS ////////////////////////////////

/**
 * Make call to server and if successful,
 * save userData to localStorage and update state,
 * else return error msg to screen
 * @param userData: ILogin
 */
export const loginUserAsync = createAsyncThunk('user/login', async (data: LoginDTO, { dispatch }) => {
  dispatch(setCoreLoading({ value: true }));

  // Make call to server
  const { success, user } = await loginService(data);

  // Check for success
  if (success && user) {
    dispatch(setUser({ user }));
    await setUserStorage(user);
  }
  await dispatch(getCompaniesAsync());

  dispatch(setCoreLoading({ value: false }));
});

/**
 * Logout user and clean data
 */
export const logoutUserAsync = createAsyncThunk('user/login', async (_, { dispatch }) => {
  dispatch(setCoreLoading({ value: true }));
  await logoutService();

  // Delete notification token from user, so that it will no longer
  // take notifications from the app until he logs in again
  // const notificationToken = await getNotificationToken();

  // const notificationToken = '';
  // if (notificationToken) {
  //   const { success } = await logoutService();
  //
  //   if (!success) {
  //     // trackEvent('Logout-User', {
  //     //   Error: 'Unidentified error while logging out',
  //     // });
  //   }
  // }

  dispatch(setUser({ user: null }));
  await clearStorage();
  queryClient?.clear();

  dispatch(setCoreLoading({ value: false }));
  // Clean redux
  batch(() => {
    dispatch(resetCore());
    dispatch(resetCompanies());
  });
});
